import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Grid, IconButton} from "@mui/material";
import InputField from "../../components/InputField";
import {Delete, QuestionAnswer} from "@mui/icons-material";
import TableData from "../../components/TableData";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import Form from "../../components/Form";
import AlertBar from "../../components/AlertBar";
import ModalPage from "../../components/ModalPage";
import ConfirmationDialog from "../../components/ConfirmationDialog";

export default function ReviewQuestionAnswer(props) {
    const form = useRef();
    const alert = useRef();
    const modal = useRef();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState({total: 0, data: []});
    const [canSubmit, setCanSubmit] = useState(true);
    const [showProgress, setShowProgress] = useState(false);
    const [name, setName] = useState();

    useEffect(() => {
        loadData();
    }, []);
    const loadData = () => {
        let url = `${BASE_URL}api/review-question-answer`;
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const ConfirmationModal = (message, action, item) => {
        let component = (<ConfirmationDialog
            message={message}
            handleClose={() => modal.current.hide()}
            handleOk={() => {
                modal.current.hide();
                if (action === "add") {
                    submit()
                } else {
                    remove(item);
                }
            }}
        />);
        modal.current.show('Confirmation', component, '40%');
    }

    const submit = () => {
        let data = {name}
        if (canSubmit && form.current.validate()) {
            setCanSubmit(false);
            alert.current.showProgress();
            window.axios
                .post(`${BASE_URL}api/review-question-answer`, data)
                .then(response => {
                    alert.current.showSuccess("Added Successfully.");
                    setCanSubmit(true);
                    setTimeout(() => {
                        loadData();
                    }, 1000)
                })
                .catch(error => {
                    setCanSubmit(true);
                    reportErrors(alert.current, error);
                });
        }
    }

    const remove = (item) => {
        alert.current.showProgress();
        window.axios
            .delete(`${BASE_URL}api/review-question-answer/${item.questionId}`, {})
            .then(response => {
                alert.current.showSuccess("Removed Successfully.");
                setCanSubmit(true);
                setTimeout(() => {
                    loadData();
                }, 1000)
            })
            .catch(error => {
                setCanSubmit(true);
                reportErrors(alert.current, error);
            });
    }

    return (<Box>
        <AlertBar ref={alert}/>
        <Form ref={form}>
            <Grid container spacing={2}>
                <Grid item xs={11}>
                    <InputField
                        required={true}
                        placeholder="Quastion"
                        type="text"
                        onChange={(value) => setName(value)}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Button
                        disabled={!canSubmit}
                        sx={{textTransform: "none"}}
                        disableElevation
                        size="medium"
                        variant="contained"
                        color="primary"
                        fullWidth={true}
                        onClick={() => ConfirmationModal("Are you sure you want to proceed?", "add")}
                    >
                        Add
                    </Button>
                </Grid>
            </Grid>
        </Form>
        <TableData
            showProgres={showProgress}
            url=""
            title="Review Questions Answers"
            columns={[
                {id: 'name', label: 'Answer', minWidth: "x-larger",},
                {
                    id: 'action',
                    label: 'Action',
                    minWidth: "small",
                    disabled: true,
                    customerRender: true,
                    valueGetter: (item) => (
                        <IconButton size="small"
                                    onClick={() => ConfirmationModal("Are you sure you want to remove?", "delete", item)}><Delete/></IconButton>)
                },
            ]}
            page={page}
            perPage={rowsPerPage}
            rows={data}
            rowClick={true}
            rowFunction={(item) => {
            }}
        />
        <ModalPage ref={modal}/>
    </Box>);
}